<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>公告</el-breadcrumb-item>
      <el-breadcrumb-item
        :to="{ path: '/dashboard/notices/' + $route.params.id }"
        >公告详情</el-breadcrumb-item
      >
      <el-breadcrumb-item>发布对象选择</el-breadcrumb-item>
    </el-breadcrumb>

    <el-row :gutter="14">
      <el-col :span="16">
        <div class="panel mt-20">
          <el-tabs>
            <el-tab-pane label="内部人员">
              <div class="filter mb-20">
                <el-form
                  label-position="left"
                  label-width="70px"
                  @submit.native.prevent
                >
                  <el-form-item label="关键字" prop="name">
                    <el-input
                      size="small"
                      v-model="userFilter.query"
                      autocomplete="off"
                      placeholder="输入姓名或手机号进行搜索"
                      @keyup.enter.native="query()"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="角色" prop="name">
                    <el-select
                      style="width: 100%"
                      v-model="userFilter.role_name"
                      size="small"
                      placeholder="请选择职位"
                    >
                      <el-option
                        v-for="(item, index) in allRoles"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
                <div>
                  <el-button type="primary" size="small" @click="query()"
                    >筛选</el-button
                  >
                  <el-button size="small" @click="userReset()">重置</el-button>
                </div>
              </div>
              <el-table
                v-if="!isMobile()"
                ref="userTable"
                :data="staffs"
                stripe
                style="width: 100%"
                @selection-change="handleUserSelectionChange"
              >
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column
                  prop="name"
                  label="姓名"
                  width="120"
                ></el-table-column>
                <el-table-column
                  prop="phone_number"
                  label="手机号"
                  align="center"
                ></el-table-column>
                <!-- <el-table-column label="区域" align="center">
                  <template slot-scope="scope">
                    {{ AreaTextMap[scope.row.area_id] }}
                  </template>
                </el-table-column> -->
                <el-table-column label="角色" align="center">
                  <template slot-scope="scope">{{
                    showRoles(scope.row.auth_roles)
                  }}</template>
                </el-table-column>
              </el-table>
              <el-pagination
                @current-change="handleUserPageChange"
                class="mt-20"
                :page-size="userFilter.size"
                :current-page.sync="userFilter.page"
                layout="total, prev, pager, next"
                :total="userTotal"
              ></el-pagination>
            </el-tab-pane>
            <el-tab-pane label="客户">
              <div class="filter mb-20">
                <el-form
                  :model="filter"
                  ref="filterForm"
                  :inline="true"
                  class="filter"
                  label-width="70px"
                  label-position="left"
                  @submit.native.prevent
                >
                  <div class="filter-block">
                    <el-form-item label="名称" prop="name">
                      <el-input
                        v-model="filter.name"
                        size="small"
                        autocomplete="off"
                        @keyup.enter.native="submitSearchForm"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="销售" prop="user_id">
                      <sale-select
                        :val="filter.user_id"
                        @change="filter.user_id = $event"
                        ref="filterUser"
                      ></sale-select>
                    </el-form-item>
                    <el-form-item label="电话销售" prop="telesale_id">
                      <telesale-select
                        :val="filter.telesale_id"
                        @change="filter.telesale_id = $event"
                        ref="filterTelesale"
                      ></telesale-select>
                    </el-form-item>
                    <el-form-item label="级别" prop="rank">
                      <CustomerRankSelect
                        v-model="filter.rank"
                        :filter="true"
                      ></CustomerRankSelect>
                    </el-form-item>
                    <el-form-item label="类别" prop="category_id">
                      <el-select
                        v-model="filter.category_id"
                        size="small"
                        placeholder="请选择"
                        style="width: 100%"
                      >
                        <el-option key="-1" label="所有" value></el-option>
                        <el-option
                          v-for="(value, name) in DealerCategories"
                          :key="name"
                          :label="value"
                          :value="name"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-form>
                <div class="mt-10 flex-row-between">
                  <div>
                    <el-button
                      type="primary"
                      size="small"
                      @click="
                        filter.page = 1
                        prePage = 0
                        submitSearchForm()
                      "
                      >筛选</el-button
                    >
                    <el-button size="small" @click="reset()">重置</el-button>
                  </div>
                </div>
              </div>

              <el-table
                v-if="!isMobile()"
                ref="dealerTable"
                :data="agents"
                stripe
                style="width: 100%"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column prop="name" label="客户名称" min-width="200">
                  <template slot-scope="scope">
                    <div class="text-primary">{{ scope.row.name }}</div>
                    {{ codeToText[scope.row.province_id]
                    }}{{ codeToText[scope.row.city_id]
                    }}{{ codeToText[scope.row.county_id] }}
                    {{ scope.row.address_detail }}
                  </template>
                </el-table-column>
                <el-table-column label="级别" align="center">
                  <template slot-scope="scope">{{
                    scope.row.service_stage.name
                  }}</template>
                </el-table-column>
                <el-table-column label="类别" align="center">
                  <template slot-scope="scope">
                    {{ DealerCategories[scope.row.category_id] }}
                  </template>
                </el-table-column>
              </el-table>
              <div class="mt-20">
                <el-pagination
                  @current-change="handlePageChange"
                  :page-size="filter.size"
                  :current-page.sync="filter.page"
                  layout="total, prev, pager, next"
                  :total="total"
                ></el-pagination>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="panel mt-20">
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 20px;
            "
          >
            <span style="font-weight: 400; color: #1f2f3d; font-size: 18px">
              已选择对象
            </span>
            <el-button type="primary" size="small" @click="handlePublish"
              >申请发布</el-button
            >
          </div>
          <div style="font-weight: bold">内部人员</div>
          <div>
            <el-tag
              disable-transitions
              size="small"
              class="mt-5 mr-5"
              v-for="(user, index) in selectedUsers"
              closable
              @close="userTagClose(user, index)"
              :key="user.id"
              >{{ user.name }}</el-tag
            >
          </div>

          <div class="mt-20" style="font-weight: bold">客户</div>
          <div>
            <el-tag
              disable-transitions
              size="small"
              class="mt-5 mr-5"
              v-for="(dealer, index) in selectedDealers"
              closable
              @close="dealerTagClose(dealer, index)"
              :key="dealer.id"
              >{{ dealer.name }}</el-tag
            >
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { regionData } from '@/util/area_tool'
import { CodeToText } from '@/util/area_tool'
import { isMobile, scrollToTop } from '@/util/index'

import {
  dealerList,
  roleList,
  userList,
  updateNoticeStatus,
} from '@/service/getData'
import { regionDataPlus } from '@/util/area_tool'
import { DealerCategories, AreaTextMap } from '@/config/global.js'
import SaleSelect from '@/components/select/sale_select'
import TelesaleSelect from '@/components/select/telesale_select'
export default {
  components: { SaleSelect, TelesaleSelect },
  data() {
    return {
      noticeID: this.$route.params.id,
      DealerCategories,
      regionDataPlus,
      isMobile,
      scrollToTop,
      codeToText: CodeToText,
      regionData: regionData,
      filter: {
        name: '',
        rank: '',
        page: 1,
        size: 20,
        category_id: '',
        user_id: null,
        telesale_id: null,
        area: [],
      },
      total: 0,
      agents: [],
      selectedDealers: [],
      prePage: 1,

      // 人员选择
      preUserPage: 1,
      selectedUsers: [],
      staffs: [],
      userFilter: {
        page: 1,
        size: 20,
        query: '',
        role_name: '',
      },
      userTotal: 0,
      allRoles: [],
      AreaTextMap,
    }
  },
  created() {
    this.getRoles()
    this.getUsers()
    this.requestDealers()
  },
  methods: {
    handleUserPageChange(e) {
      this.userFilter.page = e
      this.getUsers()
    },
    query() {
      this.preUserPage = 0
      this.userFilter.page = 1
      this.getUsers()
    },
    async getUsers() {
      let data = {
        size: this.userFilter.size,
        page: this.userFilter.page - 1,
        query: this.userFilter.query,
        status: 1,
        role_name: this.userFilter.role_name,
      }
      let res = await userList(data)
      if (res.code == 0) {
        this.staffs = res.data.list
        this.userTotal = res.data.total

        this.$nextTick(() => {
          let users = this.selectedUsers
          if (users && users.length > 0) {
            this.staffs.map((item, index) => {
              if (users.filter((user) => user.id == item.id).length > 0) {
                this.$refs.userTable.toggleRowSelection(this.staffs[index])
              }
            })
          }
          this.preUserPage = this.userFilter.page
        })
      }
    },
    userReset() {
      this.preUserPage = 0
      this.userFilter.page = 1
      this.userFilter.role_name = ''
      this.userFilter.query = ''
      this.getUsers()
    },
    async getRoles() {
      let res = await roleList()
      if (res.code == 0) {
        this.allRoles = res.data.list.filter((item) => item.status == 1)
      }
    },
    showRoles(roles) {
      if (!roles) return ''
      let names = roles.map((item) => {
        return item.name
      })
      return names.join(' / ')
    },
    handleUserSelectionChange(val) {
      if (this.preUserPage == this.userFilter.page) {
        this.staffs.map((item) => {
          let index1 = val.indexOf(item)
          let index2 = this.selectedUsers.filter((u) => u.id == item.id).length

          if (index1 >= 0 && index2 == 0) {
            this.selectedUsers.push(item)
          } else if (index1 == -1 && index2 > 0) {
            index2 = this.selectedUsers.indexOf(
              this.selectedUsers.filter((u) => u.id == item.id)[0]
            )
            this.selectedUsers.splice(index2, 1)
          }
        })
      }
    },
    userTagClose(user, index) {
      let users = this.staffs.filter((item) => item.id == user.id)
      if (users.length > 0) {
        this.$refs.userTable.toggleRowSelection(users[0])
      } else {
        this.selectedUsers.splice(index, 1)
      }
    },

    async requestDealers() {
      const data = {
        page: this.filter.page - 1,
        name: this.filter.name,
        rank: this.filter.rank,
        size: this.filter.size,
        category_id: this.filter.category_id || 0,
        user_id: this.filter.user_id || 0,
        telesale_id: this.filter.telesale_id || 0,
        status: 1,
      }

      let area = this.filter.area
      if (area.length > 0) {
        data.province = area[0]
      }
      if (area.length > 1) {
        data.city = area[1]
      }
      if (area.length > 2) {
        data.county = area[2]
      }

      let res = await dealerList(data)
      if (res.code == 0) {
        this.agents = res.data.list
        this.total = res.data.total

        this.$nextTick(() => {
          let dealers = this.selectedDealers
          if (dealers && dealers.length > 0) {
            this.agents.map((item, index) => {
              if (dealers.filter((dealer) => dealer.id == item.id).length > 0) {
                this.$refs.dealerTable.toggleRowSelection(this.agents[index])
              }
            })
          }
          this.prePage = this.filter.page
        })
      }
    },
    handlePageChange(e) {
      this.filter.page = e
      this.requestDealers()
    },
    handleSelectionChange(val) {
      if (this.prePage == this.filter.page) {
        this.agents.map((item) => {
          let index1 = val.indexOf(item)
          let index2 = this.selectedDealers.filter(
            (u) => u.id == item.id
          ).length

          if (index1 >= 0 && index2 == 0) {
            this.selectedDealers.push(item)
          } else if (index1 == -1 && index2 > 0) {
            index2 = this.selectedDealers.indexOf(
              this.selectedDealers.filter((u) => u.id == item.id)[0]
            )
            this.selectedDealers.splice(index2, 1)
          }
        })
      }
    },
    dealerTagClose(dealer, index) {
      let items = this.agents.filter((item) => item.id == dealer.id)
      if (items.length > 0) {
        this.$refs.dealerTable.toggleRowSelection(items[0])
      } else {
        this.selectedDealers.splice(index, 1)
      }
    },
    submitSearchForm() {
      this.requestDealers()
    },

    reset() {
      this.prePage = 0
      this.filter.name = ''
      this.filter.rank = ''
      this.filter.category_id = ''
      this.filter.area = []
      this.filter.page = 1
      this.filter.user_id = null
      this.filter.telesale_id = null
      this.requestDealers()
    },

    async handlePublish() {
      if (this.selectedUsers.length == 0 && this.selectedDealers.length == 0) {
        this.$alert('通知对象不能为空，请重新选择！')
        return
      }

      let userIDs = this.selectedUsers.map((item) => {
        return item.id
      })

      let dealerIDs = this.selectedDealers.map((item) => {
        return item.id
      })
      this.$confirm('确认申请发布吗', '操作提示')
        .then(() => {
          updateNoticeStatus({
            id: parseInt(this.noticeID),
            publish_user_ids: userIDs,
            publish_dealer_ids: dealerIDs,
          }).then((res) => {
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message:
                  res.data.status == 1 ? '发布成功' : '提交成功，请等待审核',
              })
              this.$router.push(`/dashboard/notices/${this.noticeID}`)
            }
          })
        })
        .catch((action) => {})
    },
  },
}
</script>